import { DataBean } from "../DataBean";

export class ProcessCycle extends DataBean {



    public async getProcessCyclesFrom(processType:any,lastDate:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProcessCyclesFrom_Number_java.util.Date", [processType,lastDate]);
    }
      public async deleteProcessCycle(cycle:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_deleteProcessCycle_Number", [cycle]);
    }
}